export const errorState = {
  message: {},
  status: null,
  id: null,
};
